import { ChangeDetectionStrategy, Component, inject, TemplateRef, viewChild } from '@angular/core';
import { TitleComponent } from '@myarvato/shared/title';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { FakeSearchbarComponent } from '@myarvato/components/fake-searchbar';
import { getSearchWidgetConfig, SearchWidgetComponent } from '@myarvato/components/search-widget';
import { SearchDtoBase } from '@myarvato/shared/models';
import { TransportSearchService } from '@myarvato/modules/transport/services';
import { SavedViewsComponent } from './components/saved-views/saved-views.component';
import { WatchedShipmentsComponent } from './components/watched-shipments/watched-shipments.component';
import { KeyIndicatorsComponent } from './components/key-indicators/key-indicators.component';
import { NewsUpdateComponent } from './components/news-update/news-update.component';
import { Router } from '@angular/router';
import { UserTabDto } from '@myarvato/core/customization';
import { getDialogResult, MyArvatoDialogService } from '@myarvato/shared/dialog';
import { TRANSPORT_SEARCH_ALLOWED_MAX_LENGTH, TransportSearchIndexDto, TransportUserTabDataDto } from '@myarvato/modules/transport/models';

@Component({
  selector: 'transport-overview-list',
  imports: [
    TitleComponent,
    TranslateModule,
    FakeSearchbarComponent,
    KeyIndicatorsComponent,
    SavedViewsComponent,
    WatchedShipmentsComponent,
    NewsUpdateComponent,
    NgbDropdownModule,
  ],
  templateUrl: './tracking-overview.component.html',
  styleUrl: './tracking-overview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrackingOverviewComponent {
  private readonly dialogService = inject(MyArvatoDialogService);
  private readonly router = inject(Router);
  private readonly searchDialogRowTemplate = viewChild.required<
    TemplateRef<{
      $implicit: SearchDtoBase;
    }>
  >('searchDialogRowTemplate');

  protected async onSearchbarClick() {
    const searchDialog = this.dialogService.showDialog(SearchWidgetComponent, {
      ...getSearchWidgetConfig(TransportSearchService),
      inputValues: {
        maxSearchLength: TRANSPORT_SEARCH_ALLOWED_MAX_LENGTH,
        rowTemplate: this.searchDialogRowTemplate(),
        trackerCategory: 'Transport - Overview - Search',
        translationKey: 'pages.transport.search-widget',
      },
    });

    const searchResult = await getDialogResult<TransportSearchIndexDto>(searchDialog);
    if (!searchResult || !searchResult?.ehGuid || !searchResult.trackingNumber) {
      return;
    }

    const newTabObj: UserTabDto<TransportUserTabDataDto> = {
      displayName: searchResult.trackingNumber,
      context: 'transport-tabs-view',
      data: { transportId: searchResult.ehGuid },
    };

    this.router
      .navigate(['transport', 'tabs'], {
        state: newTabObj,
      })
      .then();
  }
}
